<template>
  <div class="app-container">
    <div class="index-tree-box">
      <type-tree ref="type_tree" show-action @on-select="onSelect" @title-click="titleClick" />
      <div class="right-box">
        <list ref="list">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="create" :disabled="this.select.Id == null" icon="el-icon-plus">添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column label="操作" fixed="right" align="center" width="80">
              <template slot-scope="{row}">
                <el-button type="text" @click="edit(row)">编辑</el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </div>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/basedata/basedoc/district/list";
import editDialog from "@/components/basedata/basedoc/district/editDialog";
import typeTree from "@/components/basedata/basedoc/district/type/tree";
import importDialog from "@/components/basedata/basedoc/district/importDialog";

export default {
  name: "district",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    typeTree,
    importDialog,
  },
  data() {
    return {
      select: {
        Id: null,
        Code: "",
        Name: "",
      },
    };
  },
  mounted() {
    this.$refs.type_tree.getData();
  },
  methods: {
    onImprot() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    onSelect(data) {
      console.log("onSelect", data);
      this.select.Id = data.DistrictId;
      this.select.Code = data.Code;
      this.select.Name = data.Name;
      this.$refs.list.getData({ IdChain: data.IdChain });
      // this.reload();
    },
    titleClick() {
      this.select.Id = null;
      this.select.Code = "";
      this.select.Name = "";
      this.$refs.list.getData({ IdChain: null });
    },
    create() {
      this.$refs.editDialog.openCreate({
        Pid: this.select.Id,
        Pcode: this.select.Code,
        Pname: this.select.Name,
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DistrictId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>